module.exports = __webpack_public_path__ + "img/logo-unimed.a68869cf.svg";